import type { SubscribeCatalogProduct } from "../types";

export const sortSubscribeProductsByPriceAsc = (
  list: SubscribeCatalogProduct[]
) =>
  [...list].sort((a, b) => {
    const aAmt =
      typeof a.unit_amount === "number"
        ? a.unit_amount
        : Number.POSITIVE_INFINITY;
    const bAmt =
      typeof b.unit_amount === "number"
        ? b.unit_amount
        : Number.POSITIVE_INFINITY;
    return aAmt - bAmt;
  });
